import { useEffect } from "react"

import LoadingComponent from "lib/components/Loading"
import { useRouter } from "next/router"

export async function getServerSideProps() {
  return {
    props: {
      privatePage: false,
    },
  }
}

function BusinessForm() {
  const router = useRouter()

  useEffect(() => {
    setTimeout(() =>
      router.replace("/business#form_leads_section")
    , 3000)
  }, [router])

  return (
    <div className="text-white">
      <LoadingComponent size="small" color="primary" />
    </div>
  )
}

export default BusinessForm
